<template>
    <div>
        <ValidationObserver class="centerx default-input" ref="form" v-slot="{handleSubmit}">
            <vs-row vs-type="flex">
                <vs-col vs-w="12">
                    <ValidationProvider
                        vid="name"
                        :name="$t('modals.Offer_name')"
                        rules="required|minmax:3,50"
                        v-slot="{ errors }"
                    >
                        <vs-input
                            ref="name"
                            name="Offer name"
                            class="w-full pr-3"
                            :label="$t('modals.Offer_name')"
                            :placeholder="$t('modals.Enter_offer_name')"
                            v-model="offerData.name"
                        />
                        <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                    </ValidationProvider>
                </vs-col>
            </vs-row>

            <div class="mt-4 text-right">
                <vs-button @click="handleSubmit(addOffer)" color="success" type="filled">{{ $t('buttons.Save') }}</vs-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import EventBus from '@/store/eventBus'
import ErrorHandler from '@/utils/errorHandler'


export default {
    name: 'AddOffer',

    props: {
        popupData: Object,
        popupType: String
    },

    components: {
        ValidationProvider,
        ValidationObserver
    },

    data() {
        return {
            offerData: {
                name: ''
            }
        }
    },

    methods: {
        async addOffer() {
            try {
                if(this.popupType === 'addOffer') {
                    await this.$store.dispatch('ADD_OFFERS', this.offerData.name.trim())
                } else {
                    await this.$store.dispatch('UPDATE_OFFER', {
                        name: this.offerData.name.trim(),
                        id: this.offerData.id
                    })
                }
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch(error) {
                if (error.response && error.response.data && error.response.data.result) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            }
        }
    },

    mounted() {
        if(this.popupType === 'editOffer') {
            this.offerData = {...this.popupData}
        }

        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>

<style scoped>
</style>
